import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {CourseDefinitionSearchModel} from "../course-definition-search.model";
import {CourseDefinitionEntityModel} from "../course-definition-entity.model";

@Component({
    selector: "wbo-course-search-page",
    templateUrl: "./course-definition-search-page.component.html",
    providers: [provideSearchModel(CourseDefinitionSearchModel), provideEntityModel(CourseDefinitionEntityModel)]
})
export class CourseDefinitionSearchPageComponent extends AbstractSearchPage {
}
